import { all, takeEvery, put, call } from 'redux-saga/effects'
import { getProductosEnCaja } from 'services/catalogo'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_PRODUCTOS_FILTERED(action) {
  try {
    const productosData = yield call(getProductosEnCaja, action.payload)
    if (productosData.ok) {
      yield put({
        type: actions.PRODUCTOS_EN_CAJA_LOAD_SUCCEDED,
        payload: productosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar los productos.')
      put({
        type: actions.PRODUCTOS_EN_CAJA_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.PRODUCTOS_EN_CAJA_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.PRODUCTOS_EN_CAJA_LOAD_REQUESTED, GET_PRODUCTOS_FILTERED)])
}
